import { render, staticRenderFns } from "./EmptyStatePreferences.vue?vue&type=template&id=30c84385&"
var script = {}
import style0 from "./EmptyStatePreferences.vue?vue&type=style&index=0&id=30c84385&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports